import { FC } from 'react';
import { DotGroup, Dot } from 'pure-react-carousel';
import { Box } from '@mui/material';

const MARGIN = '4px';
const RADIUS = '50%';

export const CarouselDotGroup: FC = () => {
  return (
    <DotGroup
      className="carousel-dot-group"
      renderDots={({ totalSlides, currentSlide, visibleSlides }) => {
        return (
          <Box
            sx={{
              textAlign: 'center',
              marginTop: '1.25rem',
              '& button.carousel__dot': {
                width: '0.5rem',
                height: '0.5rem',
                padding: 0,
                marginX: MARGIN,
                border: 'none',
                borderRadius: RADIUS,
                backgroundColor: 'grey.300'
              },
              '& button.carousel__dot:enabled': {
                cursor: 'pointer'
              },
              '& button.carousel__dot--selected': {
                backgroundColor: 'heaven.main',
                marginX: 0,
                borderRadius: 'unset'
              },
              '& button.carousel__dot.first-visible-item': {
                marginLeft: MARGIN,
                borderTopLeftRadius: RADIUS,
                borderBottomLeftRadius: RADIUS
              },
              '& button.carousel__dot.last-visible-item': {
                marginRight: MARGIN,
                borderTopRightRadius: RADIUS,
                borderBottomRightRadius: RADIUS
              }
            }}
          >
            {[...Array(totalSlides).keys()].map((_, index) => {
              const classNames = [];
              if (currentSlide !== undefined && currentSlide === index) {
                classNames.push('first-visible-item');
              }
              if (
                currentSlide !== undefined &&
                visibleSlides !== undefined &&
                currentSlide + visibleSlides - 1 === index
              ) {
                classNames.push('last-visible-item');
              }
              return <Dot key={index} slide={index} className={classNames.join(' ')} />;
            })}
          </Box>
        );
      }}
    />
  );
};
